'use strict';
require('../../../modules/es.object.to-string');
require('../../../modules/es.regexp.exec');
require('../../../modules/es.string.match-all');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('String', 'matchAll');
